<template>
  <div class="prizes">
    <div class="title">
      <AppSubTitle :ratio="0.75" v-text="title"/>
      <AppSubTitle :ratio="0.5" v-text="description"/>
    </div>

    <ul ref="ul" :class="[`span-${span}`, { odd }]">
      <PrizeItem
        v-for="item of items"
        :key="item.id"
        v-bind="item"
      />

      <AppButton
        @click="$emit('play')"
        v-text="'ИГРАТЬ'"
        id="start-game"
        bold
      />
    </ul>
  </div>
</template>


<script>
import AppTitle from '@/components/game/ui/AppTitle';
import AppButton from '@/components/game/ui/AppButton';
import AppSubTitle from '@/components/game/ui/AppSubTitle';
import PrizeItem from './Item';

export default {
  name: 'PrizeList',

  emits: ['play'],

  components: {
    AppTitle,
    AppButton,
    AppSubTitle,
    PrizeItem,
  },

  props: {
    title: String,
    description: String,
    items: Object,
  },

  computed: {
    odd: ths => Object.keys(ths.items).length % 2,
    span: ths => 3 - Object.keys(ths.items).length % 3,
  },
};
</script>


<style lang="scss" scoped>
.prizes {
  display: flex;
  flex-direction: column;
  color: var(--color-secondary);
  gap: 4px;

  .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    text-align: center;

    h2:nth-of-type(1) {
      font-size: 40px;
    }

    h2:nth-of-type(1) {
      font-size: 32px;
    }
  }

  ul {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(calc((100% - 20px) / var(--max-columns)), 1fr));
    gap: 8px;
    margin: 4px 0 0 0;
    padding: 0;

    @media screen and (max-width: 800px) and (orientation: portrait) {
      --max-columns: 2;

      &.odd > .item:nth-of-type(1) {
        grid-column: span 2;
        aspect-ratio: 6;
      }

      & > *:not(.item) {
        margin-top: 12px;
        grid-column: span var(--max-columns);
      }
    }

    @media screen and (min-width: 800px) and (orientation: landscape) {
      --max-columns: 3;
      gap: 10px;

      &.span-2 > .item:nth-of-type(1) {
        grid-column: span 2;
        aspect-ratio: auto;
      }

      &.span-3 > *:not(.item) {
        grid-column: span var(--max-columns);
      }

      & > *:not(.item) {
        border-radius: 12px;
        height: 100%;
      }

      & > button#start-game {
        font-size: 30px;
      }
    }
  }
}
</style>